module.exports = __webpack_public_path__ + "76170e2ab12b2c0cb55be2217fc997e4.svg";